export default {
  'app.settings.menuMap.basic': 'الإعدادات الأساسية',
  'app.settings.menuMap.security': 'إعدادات الأمان',
  'app.settings.menuMap.binding': 'ربط الحساب',
  'app.settings.menuMap.notification': 'إشعارات الرسائل',
};
